import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, inject } from '@angular/core';
import { FileManagerLibFINComponent } from '../../file-manager-lib-fin/file-manager-lib-fin.component';
import Swal from 'sweetalert2';
import { FormControl, Validators } from '@angular/forms';
import { Annexe_ID, Annexe_Send, Annexes_Files, Task_FIN, WorkFlow_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Create_WF/WorkFlow_FIN.interface';
import { User_CDMS, User_CDMS_Not_Dup } from 'src/app/Interfaces/Interfaces-Global/User_CDMS.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { firstValueFrom, Subscription } from 'rxjs';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { FILE_CAP_Annexe } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { FormTemplateService } from 'src/app/Services/Forms/form-template.service';
import { Form_Template, Form_Template_With_Fields, Response_Forms } from 'src/app/Interfaces/Forms/FormTemplate.interface';
import { FormModalService } from 'src/app/Services/Forms/form-modal.service';
import { LibraryFINService } from 'src/app/Services/Libraries/General-FIN/library-fin.service';
import { LlamaIndexService } from 'src/app/Services/LlamaIndex/llama-index.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { AutocompleteComponent } from 'angular-ng-autocomplete';

@Component({
  selector: 'app-add-new-fprocess-fin',
  templateUrl: './add-new-fprocess-fin.component.html',
  styleUrls: ['./add-new-fprocess-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css'],
  standalone: false
})
export class AddNewFProcessFINComponent extends FileManagerLibFINComponent implements OnChanges, OnDestroy {

  private readonly FileNameFormatHelpText = 'Formato esperado: <CODIGO>_<OBJETIVO>.ext (separador permitido: _). Ejemplo: FOL123_Manual de Calidad.docx';
  public UseOCR_Local: boolean = true;
  public UseOCR_Cloud: boolean = false;

  public ToggleOCR_Local(): void {
    this.UseOCR_Local = !this.UseOCR_Local;
    if (this.UseOCR_Local) {
      this.UseOCR_Cloud = false;
    }
  }

  public ToggleOCR_Cloud(): void {
    this.UseOCR_Cloud = !this.UseOCR_Cloud;
    if (this.UseOCR_Cloud) {
      this.UseOCR_Local = false;
    }
  }

  // Override: La carga individual acepta cualquier tipo de archivo.
  // El filtro de tipo de archivo solo aplica a carga masiva (On_Select_Files_Massive_FIN).
  public override Is_Valid_File(_fileName: string): boolean {
    return true;
  }

  public VisibleReviewers: number[] = [1];
  public ReviewerUsersUnified: User_CDMS[] = [];
  public ReviewerUsersBySlot: { [key: number]: User_CDMS[] } = { 1: [], 2: [], 3: [], 4: [] };
  public ActualReviewerCount: number = 0; // Número real de revisores del backend
  private RequiredReviewerSlots: Set<number> = new Set<number>();
  public IsLoadingReviewers: boolean = false; // Flag para deshabilitar submit mientras carga revisores
  public RenderReviewerAutocomplete: boolean = true;
  private RebuildAutocompleteTimeout?: ReturnType<typeof setTimeout>;

  // Form Templates integration
  private formTemplateService = inject(FormTemplateService);
  private formModalService = inject(FormModalService);
  private LibraryFINService = inject(LibraryFINService);
  private formModalSub: Subscription | null = null;
  public FormTemplates: Form_Template[] = [];
  public SelectedFormTemplateOption: Form_Template | null = null;
  public SelectedFormTemplate: Form_Template_With_Fields | null = null;
  public FormFieldValues: { ID_Field: number, Value: string | null }[] = [];
  public FormFieldFiles: { ID_Field: number, File: File }[] = [];
  public IsFormCompleted: boolean = false;

  @Input() override Permission_FMF!: Permission_Folder_FIN;
  @Input() override All_FAF_FIN!: FILE_FIN[];
  @Input() override Route_Level_Global!: string;

  @Output() IsUploadFINBool = new EventEmitter<any>();

  @ViewChild('AddFile')
  MyInputAddFile!: ElementRef;

  @ViewChild('AddFileAnnexe')
  MyInputAddFileAnnexe!: ElementRef;

  @ViewChildren(AutocompleteComponent)
  ReviewerAutocompleteComponents!: QueryList<AutocompleteComponent>;

  ngOnChanges(): void {
    this.InitializeReviewersFromBackend();
    this.LoadFormTemplates();
  }

  private InitializeReviewersFromBackend(): void {
    this.LoadActualReviewerCount().finally(() => {
      this.RefreshReviewerUsersUnified();
      this.SyncVisibleReviewersWithPolicy();
      this.GenerateDynamicApproverControls();
      this.EnaOrDis_Optional_Reviewers();
    });
  }

  private LoadFormTemplates(): void {
    if (this.FormTemplates.length > 0) return;
    this.formTemplateService.GetAllFormTemplates(2).subscribe({
      next: (res: Response_Forms) => {
        if (res.success) {
          this.FormTemplates = res.operation;
        }
      }
    });
  }

  public OnFormTemplateSelect(event: any): void {
    console.log('[FORMS] OnFormTemplateSelect called', event);
    const selected = event.value;
    if (!selected) {
      console.log('[FORMS] Cleared selection');
      this.SelectedFormTemplate = null;
      this.SelectedFormTemplateOption = null;
      this.FormFieldValues = [];
      this.RestoreFileValidators();
      return;
    }

    console.log('[FORMS] Loading template ID:', selected.ID);
    this.formTemplateService.GetFormTemplateById(selected.ID).subscribe({
      next: (res: Response_Forms) => {
        console.log('[FORMS] Template loaded:', res.success, res.operation);
        if (res.success) {
          this.SelectedFormTemplate = res.operation;
          console.log('[FORMS] Fields:', this.SelectedFormTemplate?.Fields?.length, this.SelectedFormTemplate?.Fields);
          this.RelaxFileValidators();
        }
      },
      error: (err: any) => {
        console.error('[FORMS] Error loading template:', err);
      }
    });
  }

  public OnFormValuesChange(values: { ID_Field: number, Value: string | null }[]): void {
    this.FormFieldValues = values;
  }

  public OnFormFilesChange(files: { ID_Field: number, File: File }[]): void {
    this.FormFieldFiles = files;
  }

  private RelaxFileValidators(): void {
    const nameControl = this.FormFIN.controls['NameFIN'];
    nameControl.clearValidators();
    nameControl.updateValueAndValidity();

    // Enable fields that depend on file being valid
    this.FormFIN.controls['Code'].enable();
    this.FormFIN.controls['Purpose'].enable();
    this.FormFIN.controls['Revision_No'].enable();
    this.EnaOrDis_Optional_Reviewers();
  }

  private RestoreFileValidators(): void {
    const nameControl = this.FormFIN.controls['NameFIN'];
    nameControl.setValidators([Validators.pattern(/.docx$|.doc$/), Validators.required]);
    nameControl.updateValueAndValidity();

    // If no file uploaded, disable dependent fields
    if (nameControl.invalid) {
      this.FormFIN.controls['Code'].disable();
      this.FormFIN.controls['Purpose'].disable();
      this.FormFIN.controls['Revision_No'].disable();
      this.EnaOrDis_Optional_Reviewers();
    }
  }

  // ======================== FORM FILLING MODAL ========================

  public OpenFormModal(): void {
    if (!this.SelectedFormTemplate) return;

    // Build preload values
    const preload: { [fieldId: number]: string | null } = {};
    for (const v of this.FormFieldValues) {
      preload[v.ID_Field] = v.Value;
    }

    // Listen for result
    this.formModalSub?.unsubscribe();
    this.formModalSub = this.formModalService.result$.subscribe((result) => {
      if (result.confirmed) {
        this.FormFieldValues = result.values;
        this.FormFieldFiles = result.files;
        this.IsFormCompleted = true;
      }
      this.formModalSub?.unsubscribe();
    });

    // Open via service
    console.log('[FORMS] Calling formModalService.open()', this.SelectedFormTemplate?.Name);
    this.formModalService.open(this.SelectedFormTemplate, preload);
  }

  ngOnDestroy(): void {
    this.formModalSub?.unsubscribe();
    if (this.RebuildAutocompleteTimeout) {
      clearTimeout(this.RebuildAutocompleteTimeout);
      this.RebuildAutocompleteTimeout = undefined;
    }
  }

  private RebuildReviewerAutocomplete(): void {
    this.RenderReviewerAutocomplete = false;

    if (this.RebuildAutocompleteTimeout) {
      clearTimeout(this.RebuildAutocompleteTimeout);
    }

    this.RebuildAutocompleteTimeout = setTimeout(() => {
      this.RenderReviewerAutocomplete = true;
      setTimeout(() => this.ResetReviewerAutocompleteState(), 0);
      this.RebuildAutocompleteTimeout = undefined;
    }, 0);
  }

  private ResetReviewerAutocompleteState(): void {
    const components = this.ReviewerAutocompleteComponents?.toArray() || [];

    components.forEach((autocomplete: AutocompleteComponent) => {
      autocomplete.isFocused = false;
      autocomplete.isOpen = false;
      autocomplete.overlay = false;
      autocomplete.query = '';
      autocomplete.filteredList = [];
      autocomplete.selectedIdx = -1;
      autocomplete.notFound = false;
    });
  }

  public ShouldDisableFields(): boolean {
    // Fields should be enabled if there's a valid file OR a form template selected
    if (this.SelectedFormTemplate) return false;
    return this.NameFileFIN.invalid;
  }

  public GetFilledFieldCount(): number {
    return this.FormFieldValues.filter(v => v.Value !== null && v.Value !== '').length;
  }

  public GetTotalFieldCount(): number {
    if (!this.SelectedFormTemplate) return 0;
    return this.SelectedFormTemplate.Fields.filter(f => f.Field_Type !== 'section').length;
  }

  public CanManageVisibleReviewers(): boolean {
    return this.Permission_FMF?.Folder?.Optional_Approvers === 1;
  }

  private IsReviewerRequiredByFolderPolicy(slot: number): boolean {
    if (this.RequiredReviewerSlots.size > 0) {
      return this.RequiredReviewerSlots.has(slot);
    }

    if (this.Permission_FMF?.Folder?.Optional_Approvers === 0) {
      return true;
    }

    // Para slots mayores a 4, no requeridos (ya que están en expansión dinámica)
    if (slot > 4) {
      return false;
    }

    if (slot === 1) return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_1.gApproverFolderFIN.Required_RG;
    if (slot === 2) return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_2.gApproverFolderFIN.Required_RG;
    if (slot === 3) return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_3.gApproverFolderFIN.Required_RG;
    return this.Permission_FMF.Users_Groups_For_Role.G_Approvers_4.gApproverFolderFIN.Required_RG;
  }

  private GetRequiredReviewerSlotsFromPolicy(): number[] {
    const requiredSlots: number[] = [];

    if (this.RequiredReviewerSlots.size > 0) {
      return Array.from(this.RequiredReviewerSlots).sort((a, b) => a - b);
    }

    for (let slot = 1; slot <= 4; slot++) {
      const approver = this.Permission_FMF?.Users_Groups_For_Role?.[`G_Approvers_${slot}` as keyof typeof this.Permission_FMF.Users_Groups_For_Role];
      const hasGroup = (approver as any)?.gApproverFolderFIN?.ID_G > 0;
      const isRequired = (approver as any)?.gApproverFolderFIN?.Required_RG === true;
      if (hasGroup && isRequired) {
        requiredSlots.push(slot);
      }
    }

    return requiredSlots;
  }

  private GetMaxReviewerSlots(): number {
    if (this.ActualReviewerCount > 0) {
      return this.ActualReviewerCount;
    }

    let configured = 0;
    for (let slot = 1; slot <= 4; slot++) {
      const approver = this.Permission_FMF?.Users_Groups_For_Role?.[`G_Approvers_${slot}` as keyof typeof this.Permission_FMF.Users_Groups_For_Role];
      if ((approver as any)?.gApproverFolderFIN?.ID_G > 0) {
        configured++;
      }
    }

    return configured;
  }

  private SyncVisibleReviewersWithPolicy(): void {
    // Mostrar solo los slots marcados como obligatorios
    this.VisibleReviewers = Array.from(this.RequiredReviewerSlots).sort((a, b) => a - b);
  }

  private GetUniqueUsers(users: User_CDMS[]): User_CDMS[] {
    const usersMap = new Map<number, User_CDMS>();

    for (const user of users) {
      if (typeof user?.ID === 'number' && !usersMap.has(user.ID)) {
        usersMap.set(user.ID, user);
      }
    }

    return [...usersMap.values()];
  }

  private RefreshReviewerUsersUnified(): void {
    const usersByGroup = this.Permission_FMF?.Users_Groups_For_Role;

    if (!usersByGroup) {
      this.ReviewerUsersUnified = [];
      this.ReviewerUsersBySlot = { 1: [], 2: [], 3: [], 4: [] };
      return;
    }

    // Recolectar todos los grupos de aprobadores (1-4 que existen en la estructura)
    const approverGroups = [
      usersByGroup.G_Approvers_1,
      usersByGroup.G_Approvers_2,
      usersByGroup.G_Approvers_3,
      usersByGroup.G_Approvers_4,
    ].filter(group => group); // Solo incluir grupos que existen

    const allUsers: User_CDMS[] = approverGroups.flatMap(group => group?.Users || []);
    this.ReviewerUsersUnified = this.GetUniqueUsers(allUsers);

    // Generar slots dinámicamente: si la carpeta tiene más de 4 revisores almacenados,
    // asignar los usuarios de su grupo respectivo o la lista unificada si no hay grupo
    const newReviewerSlots: { [key: number]: User_CDMS[] } = {};
    const maxSlots = Math.max(4, this.GetMaxReviewerSlots());

    for (let i = 1; i <= maxSlots; i++) {
      let specificUsers: User_CDMS[] | undefined = undefined;

      if (i === 1 && usersByGroup.G_Approvers_1?.Users?.length > 0) {
        specificUsers = usersByGroup.G_Approvers_1.Users;
      } else if (i === 2 && usersByGroup.G_Approvers_2?.Users?.length > 0) {
        specificUsers = usersByGroup.G_Approvers_2.Users;
      } else if (i === 3 && usersByGroup.G_Approvers_3?.Users?.length > 0) {
        specificUsers = usersByGroup.G_Approvers_3.Users;
      } else if (i === 4 && usersByGroup.G_Approvers_4?.Users?.length > 0) {
        specificUsers = usersByGroup.G_Approvers_4.Users;
      }

      if (specificUsers) {
        newReviewerSlots[i] = this.GetUniqueUsers(specificUsers);
      } else {
        newReviewerSlots[i] = [...this.ReviewerUsersUnified];
      }
    }

    this.ReviewerUsersBySlot = newReviewerSlots;
  }

  public GetApproverControlName(slot: number): string {
    return `Approver${slot}`;
  }

  public GetReviewerUsers(slot: number): User_CDMS[] {
    return this.ReviewerUsersBySlot[slot] || [];
  }

  public TrackByReviewerSlot(_index: number, slot: number): number {
    return slot;
  }

  private OpenReviewerAutocomplete(slot: number): void {
    if (this.ShouldDisableFields()) return;

    const currentComponents = this.ReviewerAutocompleteComponents?.toArray() || [];
    const visibleIndex = this.VisibleReviewers.indexOf(slot);
    if (visibleIndex < 0) return;

    const autocomplete = currentComponents[visibleIndex];
    if (!autocomplete) return;

    // Defensive reset: this library can keep stale focus/open flags between modal uses.
    autocomplete.isFocused = false;
    autocomplete.isOpen = false;
    autocomplete.overlay = false;
    autocomplete.selectedIdx = -1;
    autocomplete.notFound = false;
    autocomplete.filteredList = [];

    autocomplete.filterList();
    autocomplete.handleOpen();
  }

  public OnReviewerAutocompleteFocus(slot: number): void {
    this.OpenReviewerAutocomplete(slot);
  }

  public OnReviewerAutocompleteHostClick(event: MouseEvent, slot: number): void {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    // No reabrir cuando se hace click en opciones o acciones internas del panel.
    if (target.closest('.suggestions-container') || target.closest('.x')) {
      return;
    }

    this.OpenReviewerAutocomplete(slot);
  }

  private GetReviewerHeaderKey(slot: number): string {
    if (slot === 1) return this.Key_Header_FIN.APPR1;
    if (slot === 2) return this.Key_Header_FIN.APPR2;
    if (slot === 3) return this.Key_Header_FIN.APPR3;
    if (slot === 4) return this.Key_Header_FIN.APPR4;
    return '';
  }

  public GetReviewerLabel(slot: number): string {
    if (slot > 4) {
      return `Revisor ${slot}`;
    }

    const HeaderKey = this.GetReviewerHeaderKey(slot);
    const Header = this.FIN_Table_Headers.find((item) => item.Key_Header === HeaderKey);
    return Header?.Name || `Revisor ${slot}`;
  }

  public CanAddReviewer(): boolean {
    const maxSlots = this.GetMaxReviewerSlots();
    return this.CanManageVisibleReviewers() && this.VisibleReviewers.length < maxSlots;
  }

  public AddReviewer(): void {
    if (!this.CanAddReviewer()) return;

    const maxSlots = this.GetMaxReviewerSlots();
    for (let i = 1; i <= maxSlots; i++) {
      if (!this.VisibleReviewers.includes(i)) {
        this.VisibleReviewers.push(i);
        this.VisibleReviewers.sort((a, b) => a - b);
        break;
      }
    }

    this.EnaOrDis_Optional_Reviewers();
  }

  public RemoveReviewer(slot: number): void {
    if (!this.CanManageVisibleReviewers()) return;
    if (!this.VisibleReviewers.includes(slot)) return;
    if (this.IsReviewerRequiredByFolderPolicy(slot)) return;
    if (this.VisibleReviewers.length === 1) return;

    this.VisibleReviewers = this.VisibleReviewers.filter((item) => item !== slot);
    this.FormFIN.controls[this.GetApproverControlName(slot)].setValue('');
    this.VisibleReviewers.sort((a, b) => a - b);
    this.EnaOrDis_Optional_Reviewers();
  }

  public CanRemoveReviewer(slot: number): boolean {
    if (!this.CanManageVisibleReviewers()) return false;
    if (!this.VisibleReviewers.includes(slot)) return false;
    if (this.IsReviewerRequiredByFolderPolicy(slot)) return false;

    return this.VisibleReviewers.length > 1;
  }

  //&===================== FUNCTIONS FOR ADD NEW FIN =====================&\\

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL ADD FIN ==================-\\
  public override ToggleModalAddFIN(CloseOrOpen: boolean): void {
    this.Sync_File_Type_Config_FIN();
    this.ResetFormFIN();
    this.Toggle_Modal_Sweet_Alert_SendFIN(false);

    // Refrescar revisores cuando se abre el modal
    if (CloseOrOpen) {
      this.IsLoadingReviewers = true; // Deshabilitar submit mientras carga
      this.RebuildReviewerAutocomplete();
      this.RefreshReviewerUsersUnified();
      this.SyncVisibleReviewersWithPolicy();
      this.GenerateDynamicApproverControls(); // Generar dinámicamente los controles

      // Cargar el conteo real de revisores obligatorios y re-sincronizar al terminar
      this.LoadActualReviewerCount().finally(() => {
        this.RefreshReviewerUsersUnified();
        this.SyncVisibleReviewersWithPolicy();
        this.GenerateDynamicApproverControls();
        this.EnaOrDis_Optional_Reviewers();
        this.IsLoadingReviewers = false; // Habilitar submit después de cargar
      });

      // DEBUG: Mostrar estado actual
      console.log('=== DEBUG ToggleModalAddFIN ===');
      console.log('ActualReviewerCount:', this.ActualReviewerCount);
      console.log('MaxReviewerSlots:', this.GetMaxReviewerSlots());
      console.log('VisibleReviewers:', this.VisibleReviewers);
      console.log('================================');
    }
    if (!CloseOrOpen) {
      this.ResetReviewerAutocompleteState();
    }

    const ModalAddFIN = document.getElementById('ModalAddFIN') as HTMLDivElement;
    CloseOrOpen ? ModalAddFIN.classList.add('active') : ModalAddFIN.classList.remove('active');

    // Reset de estado del botón de envío (Manual DOM Reset para animaciones)
    setTimeout(() => {
      const Text_Btn = document.getElementById('Text-Btn') as HTMLSpanElement;
      const Send_Icon = document.getElementById('Send-Icon') as HTMLElement;
      const Check_Icon = document.getElementById('Check-Icon') as HTMLElement;
      const Btn = document.getElementById('BtnSavedFIN') as HTMLButtonElement;

      if (Text_Btn && Send_Icon && Check_Icon) {
        Text_Btn.textContent = this.GetSubmitButtonText();
        Text_Btn.style.transform = `translateX(0px)`;
        Text_Btn.style.transition = 'none';
        Send_Icon.style.transform = `scale(1) translateX(0px)`;
        Send_Icon.style.transition = 'none';
        Check_Icon.style.opacity = `0`;
        Check_Icon.style.transform = 'translateY(-80px)';
        if (Btn) Btn.disabled = false;
      }
    }, 50);
  }

  private async LoadActualReviewerCount(): Promise<void> {
    try {
      const folderID = this.Permission_FMF?.Folder?.ID || this.ID_Folder_Level;
      if (!folderID || folderID === 0) {
        console.log('No folder ID, skipping reviewer count load');
        return;
      }

      // Llamar al endpoint Get_Groups_In_Folder_FIN para obtener el conteo real
      const response = await firstValueFrom(
        this.LibraryFINService.Get_Groups_In_Folder_FIN({ ID_Folder: folderID })
      );

      const groupsApprovers = Array.isArray(response?.operation?.GroupsApprovers)
        ? response.operation.GroupsApprovers
        : [];

      if (response?.success) {
        const activeApprovers = groupsApprovers.filter((group: any) => group?.ID_G > 0);
        this.ActualReviewerCount = activeApprovers.length;
        this.RequiredReviewerSlots = new Set<number>();
        activeApprovers.forEach((group: any, index: number) => {
          if (group?.Required_RG === true) {
            this.RequiredReviewerSlots.add(index + 1);
          }
        });
        console.log('Actual reviewer count from backend:', this.ActualReviewerCount);
      } else {
        console.log('No reviewer data in response');
        this.ActualReviewerCount = 0;
        this.RequiredReviewerSlots.clear();
      }
    } catch (error) {
      console.error('Error loading actual reviewer count:', error);
      this.ActualReviewerCount = 0;
      this.RequiredReviewerSlots.clear();
    }
  }

  private GenerateDynamicApproverControls(): void {
    // Obtener el máximo número de revisores que debe mostrarse
    const maxSlots = this.GetMaxReviewerSlots();

    // Por cada slot desde 1 hasta maxSlots, asegurar que existe el control
    for (let i = 1; i <= maxSlots; i++) {
      const controlName = `Approver${i}`;

      // Si el control ya existe, hacer nada
      if (this.FormFIN.get(controlName)) {
        continue;
      }

      // Si no existe, crearlo
      this.FormFIN.addControl(
        controlName,
        new FormControl({ value: '', disabled: true }, Validators.required)
      );
    }
  }

  private EnaOrDis_Optional_Reviewers() {

    const maxSlots = Math.max(4, this.GetMaxReviewerSlots());
    for (let i = 1; i <= maxSlots; i++) {
      const controlName = this.GetApproverControlName(i);
      const control = this.FormFIN.get(controlName);
      if (!control) continue;
      const isVisible = this.VisibleReviewers.includes(i);
      const onlyOneReviewerVisible = this.VisibleReviewers.length === 1 && this.VisibleReviewers[0] === i;
      const shouldDisableControl = !isVisible || this.NameFileFIN.invalid;

      shouldDisableControl ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });

      if (isVisible && (this.IsReviewerRequiredByPolicy(i) || onlyOneReviewerVisible)) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }

      if (!isVisible) {
        control.setValue('');
      }

      control.updateValueAndValidity();
    }

  }

  private IsReviewerRequiredByPolicy(slot: number): boolean {
    if (!this.VisibleReviewers.includes(slot)) return false;

    return this.IsReviewerRequiredByFolderPolicy(slot);
  }

  //-================== FUNCTTION FOR RESET FORM FIN AND FILEAUX ==================-\\
  private ResetFormFIN(): void {
    this.FormFIN.reset();
    this.VisibleReviewers = [1];
    this.SyncVisibleReviewersWithPolicy();
    this.FileAuxAddFIN = {
      FileData: null,
      FileName: ''
    };
    this.FormFIN.controls['NameFIN'].setValue('');
    this.FormFIN.controls['Code'].setValue('');
    this.FormFIN.controls['Purpose'].setValue('');
    this.MyInputAddFile.nativeElement.value = null;
    this.MyInputAddFileAnnexe.nativeElement.value = null;
    this.FileAuxAddFIN_Annexes = [];
    // Reset form template state
    this.SelectedFormTemplate = null;
    this.SelectedFormTemplateOption = null;
    this.FormFieldValues = [];
    this.FormFieldFiles = [];
    this.IsFormCompleted = false;
    this.formModalSub?.unsubscribe();
    this.RestoreFileValidators();
  }

  private ParseCodeAndPurposeFromFileName(fileName: string): { code: string; purpose: string } | null {
    const rawName = `${fileName || ''}`.trim().normalize('NFC');
    if (rawName === '') return null;

    const dotIndex = rawName.lastIndexOf('.');
    const baseName = dotIndex > 0 ? rawName.slice(0, dotIndex).trim() : rawName;

    const separatorMatch = baseName.match(/[_]/);
    if (!separatorMatch || separatorMatch.index === undefined) return null;

    const separatorIndex = separatorMatch.index;
    const code = baseName.slice(0, separatorIndex).trim();
    const purposeRaw = baseName.slice(separatorIndex + 1).trim();

    if (code === '' || purposeRaw === '') return null;

    const purpose = separatorMatch[0] === '_' ? purposeRaw.replace(/_/g, ' ').trim() : purposeRaw;

    return { code, purpose };
  }

  private ApplyCodeAndPurposeFromFileName(fileName: string): boolean {
    const parsedData = this.ParseCodeAndPurposeFromFileName(fileName);

    if (!parsedData) {
      this.FormFIN.controls['Code'].setValue('');
      this.FormFIN.controls['Purpose'].setValue('');
      this.FormFIN.controls['Code'].markAsTouched();
      this.FormFIN.controls['Purpose'].markAsTouched();
      this.FormFIN.controls['Code'].updateValueAndValidity();
      this.FormFIN.controls['Purpose'].updateValueAndValidity();
      return false;
    }

    this.FormFIN.controls['Code'].setValue(parsedData.code);
    this.FormFIN.controls['Purpose'].setValue(parsedData.purpose);
    this.FormFIN.controls['Code'].markAsTouched();
    this.FormFIN.controls['Purpose'].markAsTouched();
    this.FormFIN.controls['Code'].updateValueAndValidity();
    this.FormFIN.controls['Purpose'].updateValueAndValidity();

    return true;
  }

  //-================== FUNCTTION FOR CHECK IF EXISIT FIN IN PATH ==================-\\
  private Check_FIN_in_Path(NameFile: string): boolean {

    let Exist: boolean = false;

    this.All_FAF_FIN.map((item: any) => {
      if (item.Name === NameFile) {
        Exist = true;
      }
    })

    return Exist;
  }

  //-================== FUNCTTION FOR SWET ALERT ==================-\\
  private See_ModalExist(): void {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'No puede guardar el proceso',
      text: '¡El proceso ya existe en este directorio!',
      confirmButtonColor: this.ColorConfirm
    }).then((results) => {
      if (results.isConfirmed) {
        this.ToggleModalAddFIN(false);
      }
    })
  }

  //-================== FUNCTTION FOR ADD FILE FIN ==================-\\
  public async AddDocument(data: Event): Promise<void> {

    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      if (this.Is_Valid_File(file.name)) {

        this.FileAuxAddFIN = {
          FileData: file,
          FileName: file.name
        }

        this.FormFIN.controls['NameFIN'].setValue(file.name);
        const hasValidNameFormat = this.ApplyCodeAndPurposeFromFileName(file.name);
        const Band = this.Check_FIN_in_Path(file.name);

        if (!hasValidNameFormat) {
          Swal.fire({
            icon: 'warning',
            title: 'Formato de nombre no valido',
            text: this.FileNameFormatHelpText,
            confirmButtonColor: this.ColorConfirm
          });
        }

        if (await this.checkFileIsEncrypted()) {
          this.Invalid_FileEncrypt(false);
          return;
        }

        this.RelaxFileValidators();
        this.EnaOrDis_Optional_Reviewers();

        if (Band) { this.See_ModalExist(); this.ResetFormFIN() }

      } else {
        this.Invalid_File();
      }

    } else {
      this.Invalid_File();
    }
  }

  private async checkFileIsEncrypted(): Promise<boolean> {
    try {

      const File_FormData = new FormData();
      File_FormData.append('File', this.FileAuxAddFIN.FileData, this.FileAuxAddFIN.FileName);

      const resVerifyFile: Response_FIN = await firstValueFrom(this.Service_FIN.Upload_CheckFileEncrypt(File_FormData));
      return resVerifyFile.operation;

    } catch (error) {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No se pudo verificar este archivo',
        text: '¡intente cargar nuevamente el archivo, si el problema persiste notifique a su supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      this.Invalid_FileEncrypt(true);
      return false;
    }
  }


  //-================== FUNCTTION FOR ADD FILE ANNEXE ==================-\\
  public async Add_Document_Annexe(data: Event): Promise<void> {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {

      if (!this.FileAuxAddFIN_Annexes.some(item => item.FileName === file.name)) {
        const isEncrypted: boolean = await this.checkAnnexeIsEncrypted({ FileData: file, FileName: file.name })

        if (!isEncrypted) {
          this.FileAuxAddFIN_Annexes.push({ FileData: file, FileName: file.name, Extension: file.name.split('.').pop() || "" });
          this.MyInputAddFileAnnexe.nativeElement.value = null;
        } else {
          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Archivo protegido con contraseña',
            text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
            confirmButtonColor: this.ColorConfirm
          });
          this.MyInputAddFileAnnexe.nativeElement.value = null;
        }
      } else {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: 'El anexo ya está cargado'
        })
      }


    }
  }

  //-================== FUNCTTION FOR DELETE FILE ANNEXE ==================-\\
  public Delete_Annexe(Name_Annexe: string): void {

    Swal.fire({
      title: 'Eliminar anexo',
      text: `¿Desea eliminar el anexo ${Name_Annexe}?`,
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: 'Sí, Eliminar',
      cancelButtonText: 'No, Cancelar',
    }).then((result => {

      if (result.isConfirmed) {
        this.FileAuxAddFIN_Annexes = this.FileAuxAddFIN_Annexes.filter(item => item.FileName !== Name_Annexe);
      }

    }))

  }


  //-================== FUNCTTION FOR SHOW MESSAGE INVALID FILE ==================-\\
  private Invalid_File(): void {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'No se puede cargar este Proceso',
      text: this.Get_Invalid_File_Message_FIN(),
      confirmButtonColor: this.ColorConfirm
    });

    this.FileAuxAddFIN = {
      FileData: null,
      FileName: ''
    }
    this.FormFIN.controls['NameFIN'].setValue('');
    this.MyInputAddFile.nativeElement.value = null;
  }

  private Invalid_FileEncrypt(error: boolean): void {
    if (!error) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Archivo protegido con contraseña',
        text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
        confirmButtonColor: this.ColorConfirm
      });
    }

    this.FileAuxAddFIN = {
      FileData: null,
      FileName: ''
    }
    this.FormFIN.controls['NameFIN'].setValue('');
    this.MyInputAddFile.nativeElement.value = null;
  }


  //-================== FUNCTTION FOR SAVE NEW FIN ==================-\\
  public SavedNewFIN(): void {

    const Id_Groups: number[] = this.Check_Notification();

    if (this.FormFIN.valid) {

      if (Id_Groups.length === 0) {
        Swal.fire({
          title: 'Sin notificación a grupos',
          text: "¡No ha seleccionado ningún grupo para notificación, ¿desea continuar sin notificaciones?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, continuar',
          cancelButtonText: 'No, Cancelar',
        }).then((results => {
          if (results.isConfirmed) {
            this.SendNewFIN(Id_Groups);
          }
        }))

      } else {

        Swal.fire({
          title: '¿Los grupos a notificar son correctos?',
          text: "Si todo esta bien, presiona el botón para continuar",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) {
            this.SendNewFIN(Id_Groups);
          }
        }))
      }

    }
  }


  //-================== FUNCTTION FOR SEND NEW FIN ==================-\\
  private async SendNewFIN(Groups: number[]): Promise<void> {

    this.ToggleModalNotification(false);

    const Tasks: Task_FIN[] = [];

    // Recorrer dinámicamente todos los revisores visibles (1 a N)
    console.log('=== SEND DEBUG ===');
    console.log('VisibleReviewers:', this.VisibleReviewers);

    for (const slot of this.VisibleReviewers) {
      const controlName = `Approver${slot}`;
      const userApprover: User_CDMS = this.FormFIN.controls[controlName]?.value;

      console.log(`Slot ${slot} (${controlName}):`, userApprover);

      if (typeof userApprover === "object" && userApprover !== null) {
        Tasks.push({ ID_Involved_User: userApprover.ID, ID_UR: slot });
      } else {
        Tasks.push({ ID_Involved_User: -1, ID_UR: slot });
      }
    }

    console.log('Tasks to send:', Tasks);
    console.log('=================');

    const Annexes: Annexes_Files[] = [];

    for (const File_A of this.FileAuxAddFIN_Annexes) {
      Annexes.push({ Name: File_A.FileName, Extension: File_A.Extension });
    }

    // If form template is selected without a file, generate PDF first
    const hasFormTemplate = this.SelectedFormTemplate !== null;
    const hasFile = this.FileAuxAddFIN.FileData !== null;
    const codeVal = this.FormFIN.controls['Code'].value;
    const purposeVal = this.FormFIN.controls['Purpose'].value;

    let generatedPdfFile: File | null = null;

    const Content_Progress = document.getElementById('Content-Progress') as HTMLDivElement;
    const Progress_Bar = document.getElementById('Progress-Bar') as HTMLDivElement;

    try {

      const Send_Icon = document.getElementById('Send-Icon') as HTMLElement;
      const Text_Btn = document.getElementById('Text-Btn') as HTMLSpanElement;

      this.OnDisabledAdd(true);

      Send_Icon.style.transform = `scale(0.5) translateX(-200px)`;
      Text_Btn.textContent = 'Enviando';
      Text_Btn.style.transform = `translateX(-10px)`;

      // Generate PDF from form if template selected
      if (hasFormTemplate) {
        Text_Btn.textContent = 'Generando PDF...';

        const pdfBlob: Blob = await firstValueFrom(
          this.formTemplateService.GeneratePDF({
            ID_Form_Template: this.SelectedFormTemplate!.ID,
            Values: this.FormFieldValues,
            Code: codeVal,
            Purpose: purposeVal
          })
        );

        const pdfFileName = `${codeVal}_${purposeVal}.pdf`;
        generatedPdfFile = new File([pdfBlob], pdfFileName, { type: 'application/pdf' });

        // If no file was uploaded, use the PDF as the main file
        if (!hasFile) {
          this.FileAuxAddFIN = {
            FileData: generatedPdfFile,
            FileName: pdfFileName
          };
          this.FormFIN.controls['NameFIN'].setValue(pdfFileName);
        }

        Text_Btn.textContent = 'Enviando';
      }

      const fileNameForWF = hasFile ? this.FormFIN.controls['NameFIN'].value : `${codeVal}_${purposeVal}.pdf`;
      const extensionForWF = fileNameForWF.split('.').pop();

      let markdownContent = '';

      const SC_Workflow_FIN: WorkFlow_FIN = {
        ID_Contributor: this.ID_User_BD,
        ID_Previous_Version: null,
        ID_Folder: this.Permission_FMF.Folder.ID,
        Name: fileNameForWF,
        Extension: extensionForWF,
        Code: codeVal,
        Purpose: purposeVal,
        Revision_No: this.FormFIN.controls['Revision_No'].value,
        Tasks: Tasks,
        Notification: Groups,
        Annexes: Annexes,
        Markdown: markdownContent
      };

      const WorkflowPayload: any = {
        ...SC_Workflow_FIN,
        UploadFileType: hasFile ? this.Get_Selected_Main_File_Type_FIN() : 'pdf',
        AllowAnyFileType: true  // Carga individual acepta cualquier tipo de archivo
      };

      const ResCreateWF: Response_FIN = await firstValueFrom(this.Service_FIN.Create_Workflow(WorkflowPayload));

      if (ResCreateWF.success) {
        const WorkFlow = ResCreateWF.operation.Workflow;
        const ID_WF = WorkFlow.ID;

        const Annexes_With_ID = ResCreateWF.operation.Annexes;

        const Route_Saved_FIN: string = encodeURIComponent(this.Route_Level_Global + '/' + ID_WF + '/' + ID_WF + '.' + SC_Workflow_FIN.Extension);

        const File_FormData = new FormData();
        File_FormData.append('FileFIN', this.FileAuxAddFIN.FileData, Route_Saved_FIN);
        File_FormData.append('useOCR', (this.UseOCR_Local || this.UseOCR_Cloud) ? 'true' : 'false');
        File_FormData.append('parserType', this.UseOCR_Cloud ? 'llama' : 'lite');
        File_FormData.append('ID_WF', `${ID_WF}`);

        Content_Progress.classList.add('active')

        this.Service_FIN.Upload_File(File_FormData).subscribe(async (event: any) => {

          if (event.status === 500) {

            this.OnDisabledAdd(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en el proceso',
              text: '¡Ha ocurrido un error al cargar el proceso, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModalAddFIN(false);
            this.IsUploadFINBool.emit(true);
          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar.style.width = value + "%";
          }

          if (event['body']) {
            this.OnDisabledAdd(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            if (this.FileAuxAddFIN_Annexes.length > 0) { await this.private_Send_Annexes(ID_WF, Annexes_With_ID) }

            // Save form submission if template was used
            if (hasFormTemplate && this.SelectedFormTemplate) {
              try {
                await firstValueFrom(this.formTemplateService.CreateSubmission({
                  ID_Form_Template: this.SelectedFormTemplate.ID,
                  ID_WF: ID_WF,
                  Library: 'FIN',
                  Values: this.FormFieldValues
                }));
              } catch (e) {
                console.error('Error saving form submission:', e);
              }
            }
            if (ResCreateWF.operation.Workflow.Status === 1) {
              this.ToggleModalAddFIN(false);
              Swal.fire({
                title: 'Proceso cargado correctamente',
                text: 'El proceso se ha cargado correctamente.',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              })
            } else {
              this.AnimationBbuttonSave();
            }
            this.IsUploadFINBool.emit({ ID_WF: ID_WF, code: codeVal, name: fileNameForWF, useOCR: this.UseOCR_Local || this.UseOCR_Cloud });
          }

        })

      }

    } catch (e) {
      Swal.fire({
        title: 'Error en el Proceso',
        text: '¡No se guardo el archivo de el Proceso en el sistema, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      this.OnDisabledAdd(false);
      Content_Progress.classList.remove('active')
      Progress_Bar.style.width = "0%";
      this.ToggleModalAddFIN(false);

    }

  }

  //-================== FUNCTTION FOR SEND ANNEXES ==================-\\
  private async private_Send_Annexes(ID_WF: number, Annexes: Annexe_ID[]): Promise<boolean> {

    return new Promise((resolve, reject) => {


      const Annexes_Send: Annexe_Send[] = [];

      for (const An_Res of Annexes) {
        const IsFind = this.FileAuxAddFIN_Annexes.find((An_R: FILE_CAP_Annexe) => An_R.FileName === An_Res.Name)
        if (IsFind !== undefined) { Annexes_Send.push({ ID: An_Res.ID, FileData: IsFind.FileData, Name: An_Res.Name, Extension: An_Res.Extension }); }
      }


      const Files_Annexes = new FormData();

      Annexes_Send.forEach((file: Annexe_Send) => {

        const Route_Saved_FIN: string = encodeURIComponent(ID_WF + '_' + file.ID + '.' + file.Extension);
        Files_Annexes.append('Files_Annexes', file.FileData, Route_Saved_FIN);

      });

      Files_Annexes.append('ID_WF', `${ID_WF}`);
      Files_Annexes.append('IsUpdate', 'false');

      const Content_Progress = document.getElementById('Content-Progress') as HTMLDivElement;
      const Progress_Bar = document.getElementById('Progress-Bar') as HTMLDivElement;

      try {

        Content_Progress.classList.add('active');

        this.Service_FIN.Upload_Annexes(Files_Annexes).subscribe(async (event: any) => {

          if (event.status === 500) {

            this.OnDisabledAdd(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en los anexos de el Proceso',
              text: '¡Ha ocurrido un error al cargar los anexos de el Proceso, informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModalAddFIN(false);

          }

          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar.style.width = value + "%";
          }

          if (event['body']) {
            this.OnDisabledAdd(false);
            Content_Progress.classList.remove('active')
            Progress_Bar.style.width = "0%";

            resolve(true);
          }

        })

      } catch (e) {

        Swal.fire({
          title: 'Error en el Proceso (Carga anexos)',
          text: '¡No se guardo el archivo anexos de el Proceso en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })

        reject(false);
      }



    })
  }

  //-================== FUNCTION FOR DISABLED BUTTONS IN FIN FORM WHILE SENDING ==================-\\
  private OnDisabledAdd(IsDisabled: boolean): void {

    const Btn = document.getElementById('BtnSavedFIN') as HTMLButtonElement;
    const Btn_Close_Add_Top = document.getElementById('Btn-Close-Add-Top') as HTMLButtonElement;
    const Btn_Close_Add_Bottom = document.getElementById('Btn-Close-Add-Bottom') as HTMLButtonElement;

    if (IsDisabled) {
      Btn.disabled = true;
      Btn_Close_Add_Top.disabled = true;
      Btn_Close_Add_Bottom.disabled = true;
    } else {
      Btn.disabled = false;
      Btn_Close_Add_Top.disabled = false;
      Btn_Close_Add_Bottom.disabled = false;
    }

  }

  //-================== FUNCTION FOR TOOGLE NOTIFICATION GROUPS ==================-\\
  public async ValidToogleFIN(): Promise<void> {

    const IsValidForm: boolean = await this.IsValidFormFIN();

    // Validate form has been filled if a template is selected
    if (this.SelectedFormTemplate && !this.IsFormCompleted) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Formulario incompleto',
        text: 'Abra y complete el formulario antes de enviar el proceso.',
        confirmButtonColor: this.ColorConfirm
      });
      return;
    }

    if (this.FormFIN.valid && IsValidForm) {

      // Swal.fire({
      //   title: '¿Los datos son correctos?',
      //   text: "Si todo esta bien, presiona el botón para continuar",
      //   icon: 'question',
      //   position: 'center-end',
      //   backdrop: 'rgba(0,0,0,0)',
      //   showCancelButton: true,
      //   confirmButtonColor: this.ColorConfirm,
      //   cancelButtonColor: this.ColorsCancel,
      //   confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
      //   cancelButtonText: 'No, Cancelar',
      // }).then((result => {
      //   if (result.isConfirmed) {
      //     // if (this.Group_Notification.length > 0) {
      //     //   this.ToggleModalNotification(true);
      //     // } else {
      //     //   Swal.fire({
      //     //     title: 'Notificación a grupos',
      //     //     text: "¡Aún no existen grupos para enviar notificación de la creación de un nuevo Proceso!",
      //     //     icon: 'question',
      //     //     confirmButtonColor: this.ColorConfirm,
      //     //   }).then((result2) => {
      //     //     if (result2.isConfirmed) {
      //     //       this.SendNewFIN([0]);
      //     //     }
      //     //   })
      //     // }
      //     this.SendNewFIN([0]);
      //   }
      // }))

      this.Toggle_Modal_Sweet_Alert_SendFIN(true);
    }

  }

  public Toggle_Modal_Sweet_Alert_SendFIN(band: boolean): void {
    const modal = document.getElementById('Sweet_Alert') as HTMLDivElement;
    setTimeout(() => { band ? (modal.classList.add('active')) : (modal.classList.remove('active')) }, 100);
  }

  public Sweet_Alert_Send_New_FIN(): void {
    this.Toggle_Modal_Sweet_Alert_SendFIN(false);
    this.SendNewFIN([0]);
  }

  //-================== FUNCTION OPEN OR CLOSE MODAL FOR NOTIFICATION ==================-\\
  private ToggleModalNotification(band: boolean): void {

    const modal = document.getElementById('ModalNotificationFIN') as HTMLDivElement;

    band ? (modal.classList.add('active')) : (modal.classList.remove('active'))

  }

  //-================== FUNCTION TO CHECK IF NOTIFICATION GROUPS ARE SELECTED ==================-\\
  private Check_Notification(): number[] {

    let Id_Groups: number[] = [];

    for (let i = 0; i < this.Group_Notification.length; i++) {
      const Group = this.Group_Notification[i];
      const CheckBox = document.getElementById(`CheckBox${i}`) as HTMLInputElement;
      if (CheckBox.checked) {
        Id_Groups.push(Group.ID);
        CheckBox.checked = false;
      }
    }

    return Id_Groups;

  }

  //-================== FUNCTION TO CHECK THAT THE USERS ARE NOT REPLICATED IN THE FORM ==================-\\
  public UserIsReplicated(Position: number): boolean {

    if (this.NameFileFIN.invalid) return false;

    const currentSlot = Position + 1;

    if (!this.VisibleReviewers.includes(currentSlot)) return false;

    const currentApprover = this.FormFIN.controls[this.GetApproverControlName(currentSlot)].value;

    if (typeof currentApprover !== 'object' || currentApprover === null) return false;

    const otherApprovers = this.VisibleReviewers
      .filter(slot => slot !== currentSlot)
      .map(slot => this.FormFIN.controls[this.GetApproverControlName(slot)].value)
      .filter((approver: User_CDMS | string | null) => typeof approver === 'object' && approver !== null) as User_CDMS[];

    return otherApprovers.some((item: User_CDMS) => item.ID === currentApprover.ID);

  }

  //-================== FUNCTION IS VALID FORM ==================-\\
  private async ValidateApproversForSlots(): Promise<boolean> {
    // Validar dinámicamente cada revisor visible
    for (const slot of this.VisibleReviewers) {
      const controlName = this.GetApproverControlName(slot);
      const control = this.FormFIN.get(controlName);

      if (!control) {
        continue; // Controla no existe, saltar
      }

      if (!control.valid) {
        Swal.fire({
          icon: 'warning',
          title: `Usuario ${this.GetReviewerLabel(slot)} no valido`,
          text: `¡No ha seleccionado a un ${this.GetReviewerLabel(slot)}, por favor seleccione uno!`,
          confirmButtonColor: this.ColorConfirm
        });

        const IdInputApprover = document.getElementById(`IdInputAuA${slot}NewFIN`) as HTMLElement;
        if (IdInputApprover) {
          IdInputApprover.classList.add('ng-invalid');
          IdInputApprover.classList.add('ng-touched');
        }
        return false;
      }

      // Validar que el valor seleccionado sea un objeto válido
      const ValueApprover: User_CDMS = control.value;
      if (!(control.value === "" || control.value === null)) {
        if (ValueApprover.ID === undefined) {
          Swal.fire({
            icon: 'warning',
            title: `Usuario ${this.GetReviewerLabel(slot)} no valido`,
            text: `¡Seleccione un usuario ${this.GetReviewerLabel(slot)} proporcionado por el sistema!`,
            confirmButtonColor: this.ColorConfirm
          });

          const IdInputApprover = document.getElementById(`IdInputAuA${slot}NewFIN`) as HTMLElement;
          if (IdInputApprover) {
            IdInputApprover.classList.add('ng-invalid');
            IdInputApprover.classList.add('ng-touched');
          }
          return false;
        }
      }
    }

    return true;
  }

  private async IsValidFormFIN(): Promise<boolean> {

    const IdInputFileNewFIN = document.getElementById('IdInputFileNewFIN') as HTMLElement; IdInputFileNewFIN.classList.remove('Is-Invalid-Form');
    const IdinputCodeOf_FIN = document.getElementById('IdinputCodeOf_FIN') as HTMLElement;
    const IdinputDescripFIN = document.getElementById('IdinputDescripFIN') as HTMLElement;
    const IdinputNoRevisFIN = document.getElementById('IdinputNoRevisFIN') as HTMLElement;

    // Skip file validations when a form template is selected (PDF will be generated)
    const hasFormTemplate = this.SelectedFormTemplate !== null && this.IsFormCompleted;

    if (!hasFormTemplate) {
      if (!this.FormFIN.controls['NameFIN'].valid) {
        Swal.fire({
          icon: 'warning',
          title: 'Archivo no valido',
          text: '¡Ingrese un archivo de Proceso!',
          confirmButtonColor: this.ColorConfirm
        })
        IdInputFileNewFIN.classList.add('Is-Invalid-Form');
        return false;
      }

      const parsedNameData = this.ParseCodeAndPurposeFromFileName(this.FormFIN.controls['NameFIN'].value);
      if (!parsedNameData) {
        Swal.fire({
          icon: 'warning',
          title: 'Formato de nombre no valido',
          text: this.FileNameFormatHelpText,
          confirmButtonColor: this.ColorConfirm
        });
        IdinputCodeOf_FIN.classList.add('ng-invalid'); IdinputCodeOf_FIN.classList.add('ng-touched');
        IdinputDescripFIN.classList.add('ng-invalid'); IdinputDescripFIN.classList.add('ng-touched');
        return false;
      }
    }

    if (!this.FormFIN.controls['Code'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Código no valido',
        text: '¡El Código del proceso es muy corto!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputCodeOf_FIN.classList.add('ng-invalid'); IdinputCodeOf_FIN.classList.add('ng-touched');
      return false;
    }

    if (!this.FormFIN.controls['Purpose'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Objetivo del proceso no valido',
        text: '¡El Objetivo del proceso es muy corto!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputDescripFIN.classList.add('ng-invalid'); IdinputDescripFIN.classList.add('ng-touched');
      return false;
    }

    if (!this.FormFIN.controls['Revision_No'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Numero de revisión no valido',
        text: '¡El número de revisión debe de ser mayor a 0, menor a 99 y debe ser un número entero!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputNoRevisFIN.classList.add('ng-invalid'); IdinputNoRevisFIN.classList.add('ng-touched');
      return false;
    }

    // Validar aprobadores dinámicamente
    const isValidApprovers = await this.ValidateApproversForSlots();
    if (!isValidApprovers) {
      return false;
    }
    const Approvers: User_CDMS_Not_Dup[] = [];

    for (const slot of this.VisibleReviewers) {
      const Approver = this.FormFIN.controls[this.GetApproverControlName(slot)].value;
      if (typeof Approver === "object" && Approver !== null) {
        Approvers.push({ ID: Approver.ID, Name: Approver.Name, ID_UR: slot });
      }
    }


    const Index_Input: number[] = [];

    for (const [index, approver] of Approvers.entries()) {
      const Approvers_Clean = [...Approvers.slice(0, index), ...Approvers.slice(index + 1, Approvers.length)]

      for (const Approver of Approvers_Clean) {
        if (Approver.ID === approver.ID) {
          Index_Input.push(Approver.ID_UR); break;
        }
      }

    }

    if (Index_Input.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuarios repetidos',
        text: '¡No puede repetir los usuarios en los campos, intente cambiar alguno usuario!',
        confirmButtonColor: this.ColorConfirm
      });

      for (const Index of Index_Input) {
        const IdInputApproverNewFIN = document.getElementById(`IdInputAuA${Index}NewFIN`) as HTMLElement;
        IdInputApproverNewFIN.classList.add('ng-invalid'); IdInputApproverNewFIN.classList.add('ng-touched');
      }

      return false;
    }


    return await this.Validate_Annexes();
  }

  //-================== FUNCTION IS VALIDATE ANNEXES ==================-\\
  private Validate_Annexes(): Promise<boolean> {

    return new Promise<any>((resolve, reject) => {

      if (this.FileAuxAddFIN_Annexes.length === 0) {
        Swal.fire({
          title: 'Sin anexos',
          text: "¡No adjunto anexos, ¿está seguro de enviar sin anexos?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: 'Sí, enviar',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) { resolve(true) } else { resolve(false) };
        }))
      } else {
        resolve(true);
      }

    })
  }

  private AnimationBbuttonSave(): void {

    const Send_Icon = document.getElementById('Send-Icon') as HTMLElement;
    const Check_Icon = document.getElementById('Check-Icon') as HTMLElement;
    const Text_Btn = document.getElementById('Text-Btn') as HTMLSpanElement;
    const Btn = document.getElementById('BtnSavedFIN') as HTMLButtonElement;




    Text_Btn.style.transform = `translateY(80px)`;
    Text_Btn.classList.remove('loading')
    Send_Icon.style.transition = `1000ms ease 230ms`;
    Send_Icon.style.transform = `scale(2) translateX(120px)`;
    setTimeout(() => {
      Check_Icon.style.opacity = `1`;

      Text_Btn.classList.add('notransition');
      Text_Btn.style.transform = `translateY(0px)`;
      Text_Btn.textContent = 'Enviado';
      Text_Btn.offsetHeight;
      Text_Btn.classList.remove('notransition');

      Check_Icon.style.transform = `translate(-20px,0px)`;
      setTimeout(() => {
        this.ToggleModalAddFIN(false);
        Text_Btn.textContent = this.GetSubmitButtonText();
        Check_Icon.style.opacity = `0`;
        Check_Icon.style.transform = 'translateY(-80px)';
        Send_Icon.style.transform = 'scale(1) translateX(0px)';
        Btn.disabled = false;
        Swal.fire({
          icon: 'success',
          title: 'Proceso enviado a revisión',
          confirmButtonColor: this.ColorConfirm
        })
      }, 500);
    }, 1000);

  }


  public GetSubmitButtonText(): string {
    if (this.SelectedFormTemplate && !this.IsFormCompleted) {
      return 'Llenar Formulario';
    }

    const noReviewers = !this.VisibleReviewers || this.VisibleReviewers.length === 0;
    const baseText = noReviewers ? 'Cargar y Aprobar Proceso' : 'Enviar Proceso a Aprobación';

    if (this.SelectedFormTemplate && this.IsFormCompleted) {
      return noReviewers ? 'Cargar y Aprobar con Formulario' : 'Cargar con Formulario';
    }

    return baseText;
  }

  public GetSubmitButtonIcon(): string {
    const noReviewers = !this.VisibleReviewers || this.VisibleReviewers.length === 0;
    return noReviewers ? 'check_circle' : 'send';
  }

  public VerifySweetAlert() {

    const Sweet_Alert = document.getElementById('Sweet_Alert') as HTMLDivElement;
    window.onclick = (event: any) => {

      if (!event.target.closest('.Sweet-Alert') && Sweet_Alert.classList.contains('active')) {
        if (Sweet_Alert.classList.contains('active')) {
          this.Toggle_Modal_Sweet_Alert_SendFIN(false);
        }
      }

    }
  }

  //&===================== END FUNCTIONS FOR ADD NEW FIN =====================&\\

}
